import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "container"]

  connect() {
    this.bindDragAndDrop()
    this.element.addEventListener("click", this.handleClick.bind(this))
  }

  disconnect() {
    this.unbindDragAndDrop()
    this.element.removeEventListener("click", this.handleClick.bind(this))
  }

  bindDragAndDrop() {
    this.element.addEventListener("dragover", this.handleDragOver.bind(this))
    this.element.addEventListener("drop", this.handleDrop.bind(this))
    this.element.addEventListener("dragenter", this.handleDragEnter.bind(this))
    this.element.addEventListener("dragleave", this.handleDragLeave.bind(this))
  }

  unbindDragAndDrop() {
    this.element.removeEventListener("dragover", this.handleDragOver.bind(this))
    this.element.removeEventListener("drop", this.handleDrop.bind(this))
    this.element.removeEventListener("dragenter", this.handleDragEnter.bind(this))
    this.element.removeEventListener("dragleave", this.handleDragLeave.bind(this))
  }

  handleDragOver(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.add("border-indigo-500")
  }

  handleDragEnter(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.add("border-indigo-500")
  }

  handleDragLeave(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.remove("border-indigo-500")
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.remove("border-indigo-500")

    const files = Array.from(event.dataTransfer.files)
    if (files.length === 0) return

    // Only take the first file for cover images
    const file = files[0]
    if (!file.type.startsWith("image/")) {
      alert("Please upload an image file")
      return
    }

    // Create a new DataTransfer object and add the file
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    
    // Update the file input
    this.inputTarget.files = dataTransfer.files
    
    // Show preview
    this.showPreview(file)
  }

  handleClick(event) {
    // If clicking on the remove button or preview, prevent opening file dialog
    if (event.target.closest("[data-action*='cover-dropzone#removeCover']") || 
        event.target.closest("[data-cover-dropzone-target='preview']")) {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    // If clicking anywhere else in the dropzone, trigger file input
    if (event.target !== this.inputTarget) {
      event.preventDefault()
      this.inputTarget.click()
    }
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (!file) return // User cancelled file selection, keep existing file

    if (!file.type.startsWith("image/")) {
      alert("Please upload an image file")
      event.target.value = "" // Reset input
      return
    }

    this.showPreview(file)
  }

  showPreview(file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.querySelector("img").src = e.target.result
      this.previewTarget.classList.remove("hidden")
      this.placeholderTarget.classList.add("hidden")
      this.containerTarget.classList.add("has-preview")
    }
    reader.readAsDataURL(file)
  }

  removeCover(event) {
    event.preventDefault()
    event.stopPropagation()

    // Clear the file input
    this.inputTarget.value = ""

    // Reset the preview
    this.previewTarget.querySelector("img").src = "#"
    this.previewTarget.classList.add("hidden")
    this.placeholderTarget.classList.remove("hidden")
    this.containerTarget.classList.remove("has-preview")
  }
} 